import { template as template_bca508bc37664ed5bcbefc7f0d3e2f39 } from "@ember/template-compiler";
import Component from '@glimmer/component';
import styles from './panel-loading-state.module.scss';
import svgJar from 'ember-svg-jar/helpers/svg-jar';
export default class RequestClinicianSearchFiltersPanelLoadingState extends Component {
    styles = styles;
    static{
        template_bca508bc37664ed5bcbefc7f0d3e2f39(`
    <div class={{this.styles.loadingState}} role="status" aria-live="polite" ...attributes>
      {{svgJar "circle-notch" class="icon-spinner" aria-label=@ariaLabel}}
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
